import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-no-content',
  templateUrl: './custom-no-content.component.html',
  styleUrls: ['./custom-no-content.component.css']
})
export class CustomNoContentComponent {
  @Input() noContent: string = '';
}
